import React from "react";

const ExpandIcon = (props: any) => {
  return (
    <svg width={18} height={18} fill="none" {...props}>
      <path
        fill="var(--color-icon-bright)"
        d="M15.75 7.313a.567.567 0 0 1-.563-.563V2.812H11.25a.567.567 0 0 1-.563-.562c0-.308.256-.563.563-.563h4.5c.308 0 .563.255.563.563v4.5a.567.567 0 0 1-.563.563ZM6.75 16.313h-4.5a.567.567 0 0 1-.563-.563v-4.5c0-.307.255-.563.563-.563.308 0 .563.256.563.563v3.938H6.75c.308 0 .563.255.563.562a.567.567 0 0 1-.563.563Z"
      />
      <path
        fill="var(--color-icon-bright)"
        d="M10.125 8.438a.556.556 0 0 1-.397-.165.566.566 0 0 1 0-.795l5.625-5.625a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795l-5.625 5.625a.556.556 0 0 1-.398.165ZM2.25 16.313a.556.556 0 0 1-.397-.165.566.566 0 0 1 0-.795l5.625-5.625a.566.566 0 0 1 .795 0 .566.566 0 0 1 0 .795l-5.625 5.625a.556.556 0 0 1-.398.165Z"
      />
    </svg>
  );
};

export default ExpandIcon;
